// socket.ts
import io from 'socket.io-client';



const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || "localhost:5002";
// console.log({ SOCKET_URL }, "SOCKET_URL");

// Type the socket using generics
const socket = io(SOCKET_URL, {
    transports: ["websocket"],
});

export default socket;
